const normalizeText = (value) => String(value ?? '').trim().toUpperCase();

export const MENSUALIDAD_FILTERS = [
  ['todos', 'Todos', '#1976d2'],
  ['esperando', 'Esperando', '#ed6c02'],
  ['termina_hoy', 'Termina Hoy', '#2e7d32'],
  ['vencidos', 'Vencidos', '#d32f2f'],
  ['renovados', 'Renovados', '#ed6c02'],
  ['cancelados', 'Cancelados', '#616161'],
];

export const getMensualidadesListParams = ({ search, filter, page, pageSize, highlightId }) => ({
  search,
  estado: filter,
  page,
  page_size: pageSize,
  ...(highlightId ? { highlight_id: highlightId } : {}),
});

const daysBetween = (from, to) => {
  const parse = (value) => {
    const [year, month, day] = String(value ?? '').split('-').map(Number);
    return year && month && day ? Date.UTC(year, month - 1, day) : NaN;
  };
  const difference = parse(to) - parse(from);
  return Number.isFinite(difference) ? Math.round(difference / 86400000) : null;
};

export const getCurrentRenovacion = (renovaciones) => {
  if (!Array.isArray(renovaciones) || renovaciones.length === 0) return null;

  const ordered = [...renovaciones].sort((a, b) => {
    const fechaFinal = String(a?.fecha_salida ?? '').localeCompare(String(b?.fecha_salida ?? ''));
    if (fechaFinal !== 0) return fechaFinal;
    const fechaInicio = String(a?.fecha_entrada ?? '').localeCompare(String(b?.fecha_entrada ?? ''));
    if (fechaInicio !== 0) return fechaInicio;
    return Number(a?.id ?? 0) - Number(b?.id ?? 0);
  });
  return ordered[ordered.length - 1];
};

export const getCurrentMensualidad = (mensualidad, today) => {
  const renovacion = getCurrentRenovacion(mensualidad?.renovaciones);
  const fechaInicio = renovacion?.fecha_entrada || mensualidad?.fecha_inicio || '';
  const fechaFinal = renovacion?.fecha_salida || mensualidad?.fecha_final || '';

  const diasRestantes = daysBetween(today, fechaFinal);
  const estadoTemporal = diasRestantes === null ? 'DESCONOCIDO'
    : diasRestantes < 0 ? 'ATRASADA'
      : diasRestantes === 0 ? 'TERMINA HOY' : 'ESPERANDO';
  const estadoContractual = mensualidad?.cancelado ? 'CANCELADA'
    : mensualidad?.renovado ? 'RENOVADO' : 'ACTIVA';
  const estado = estadoContractual === 'ACTIVA' ? estadoTemporal : estadoContractual;
  const faltanTexto = estadoContractual === 'CANCELADA' ? 'CANCELADA' : (
    estadoTemporal === 'ATRASADA' ? 'ATRASADA'
      : estadoTemporal === 'TERMINA HOY' ? 'TERMINA HOY'
        : diasRestantes === 1 ? '1 día'
          : diasRestantes > 1 ? `${diasRestantes} días` : '—'
  );
  const visualCategory = estadoContractual === 'CANCELADA' ? 'cancelada'
    : estadoTemporal === 'ATRASADA' ? 'vencida'
        : estadoTemporal === 'TERMINA HOY' ? 'termina_hoy'
          : estadoTemporal === 'ESPERANDO' ? 'esperando' : 'desconocida';
  const sortPriority = {
    'TERMINA HOY': 0,
    ESPERANDO: 1,
    ATRASADA: 2,
    VENCIDA: 2,
    DESCONOCIDO: 3,
  }[estadoTemporal] ?? 3;
  const prioridadFinal = estadoContractual === 'CANCELADA' ? 4 : sortPriority;

  return {
    fechaInicio,
    fechaFinal,
    estado: normalizeText(estado),
    estadoContractual,
    estadoNegocio: estadoContractual,
    estadoTemporal,
    diasRestantes,
    faltanTexto,
    visualCategory,
    sortPriority: prioridadFinal,
    renovacionActual: renovacion,
    renovacion,
    fechaInicioActual: fechaInicio,
    fechaFinalActual: fechaFinal,
    textoFaltan: faltanTexto,
    categoriaVisual: visualCategory,
  };
};

const matchesSearch = (mensualidad, search) => {
  const term = normalizeText(search);
  if (!term) return true;
  const cliente = mensualidad?.cliente || {};
  const historial = mensualidad?.historial || {};
  return [
    mensualidad?.id,
    historial?.placa,
    cliente?.nombre,
    cliente?.apellidos,
    cliente?.documento,
  ].some((value) => normalizeText(value).includes(term));
};

export const filterMensualidades = (mensualidades, filter, today, search = '') => {
  const filtered = (Array.isArray(mensualidades) ? mensualidades : []).filter((mensualidad) => {
    if (!matchesSearch(mensualidad, search)) return false;
    if (filter === 'todos') return true;

    const current = getCurrentMensualidad(mensualidad, today);
    if (filter === 'cancelados') return current.estadoContractual === 'CANCELADA';
    if (filter === 'renovados') return current.estadoContractual === 'RENOVADO';
    if (current.estadoContractual === 'CANCELADA') return false;
    if (filter === 'esperando') return current.estadoTemporal === 'ESPERANDO';
    if (filter === 'termina_hoy') return current.estadoTemporal === 'TERMINA HOY';
    if (filter === 'vencidos') return current.estadoTemporal === 'ATRASADA';
    return true;
  });

  if (filter !== 'todos') return filtered;
  return [...filtered].sort((a, b) => {
    const currentA = getCurrentMensualidad(a, today);
    const currentB = getCurrentMensualidad(b, today);
    if (currentA.sortPriority !== currentB.sortPriority) {
      return currentA.sortPriority - currentB.sortPriority;
    }
    const dateOrder = currentA.fechaFinal.localeCompare(currentB.fechaFinal);
    if (dateOrder !== 0) return currentA.estadoTemporal === 'ESPERANDO' ? dateOrder : -dateOrder;
    return Number(b?.id ?? 0) - Number(a?.id ?? 0);
  });
};
